export var MutualFundsSchemesMapper = function (mutualFundsSchemes, dataPerPage) {
    var _a, _b, _c, _d;
    var mutualFundsSummaryResponse = {
        mutualFundsSchemes: [],
        totalPages: Math.ceil(((_a = mutualFundsSchemes === null || mutualFundsSchemes === void 0 ? void 0 : mutualFundsSchemes.data) === null || _a === void 0 ? void 0 : _a.totalRecords) / dataPerPage),
    };
    if (((_b = mutualFundsSchemes === null || mutualFundsSchemes === void 0 ? void 0 : mutualFundsSchemes.data) === null || _b === void 0 ? void 0 : _b.mutualFundSummary.length) > 0) {
        mutualFundsSummaryResponse.mutualFundsSchemes =
            (_d = (_c = mutualFundsSchemes === null || mutualFundsSchemes === void 0 ? void 0 : mutualFundsSchemes.data) === null || _c === void 0 ? void 0 : _c.mutualFundSummary) === null || _d === void 0 ? void 0 : _d.map(function (record) {
                return {
                    aum: record.fundSize,
                    category: record.catName,
                    expenseRatio: record.expenseRatio,
                    schemeName: record.schemeName,
                    schemeCode: record.grpCode,
                    rating: record.rating,
                    subCategory: record.subCatName,
                    year1: record.year1,
                    year3: record.year3,
                    year5: record.year5,
                    isin: record.isin,
                    schCd: record.schemeCode,
                    isNew: record.isNew,
                    isFeatured: record.isFeatured,
                    schemeGroup: record.schemeGroup,
                    schemePlan: record.schemePlan,
                    amcLogo: record === null || record === void 0 ? void 0 : record.amcLogo,
                    isCtaAllowed: (record === null || record === void 0 ? void 0 : record.isCtaAllowed) === "Y",
                    isOrderAllowed: (record === null || record === void 0 ? void 0 : record.isOrderAllowed) === "Y",
                };
            });
    }
    return mutualFundsSummaryResponse;
};
